import { fetchSlimProfiles } from "@/api/hooks/profile";
import { useAppSession } from "@/auth/AppSessionContext";
import { useProfileAndTabParams } from "@/hooks";
import { TimeMachineProvider } from "@/models/time-control/timeStateContext";
import NotFoundPage from "@/pages/not-found";
import WorkspacePage from "@/pages/workspace";
import { useAppDispatch } from "@/reducer";
import { PROFILE_FETCH_STATUS, useProfiles } from "@/reducer/ProfileState";
import { LayersApiContext, useLayersApiContextValue } from "@/weather-parameters";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React, { useEffect } from "react";

export default function ActivateWorkspace() {
  const { sessionActivated } = useAppSession();
  const layersApiContextValue = useLayersApiContextValue();
  const dispatch = useAppDispatch();
  const { tabId, profileId } = useProfileAndTabParams();
  const { profiles, fetchStatus } = useProfiles();
  const profile = profiles[profileId];
  const tabExists = profile?.tabs?.some((tab) => tab.id === tabId);
  useEffect(() => {
    // TODO: There is a crash when login in again after the session expired without checking for sessionActivated. This should just be a workaround.
    // Find a better solution!

    if (sessionActivated) {
      dispatch(fetchSlimProfiles());
    }
  }, [sessionActivated, dispatch]);

  if (fetchStatus === PROFILE_FETCH_STATUS.idle || fetchStatus === PROFILE_FETCH_STATUS.loading) {
    return <mm-loader size="xlarge" />;
  }

  if (fetchStatus === PROFILE_FETCH_STATUS.failed) {
    return <Trans id="profile.fetch.failure">Failed to load profiles from server</Trans>;
  }

  if (profile && !tabExists) {
    const descr = t`The tab you’re looking for does not exist. You can head back to your dashboard or start fresh.`;
    return <NotFoundPage description={descr} firstTabId={profile.tabs[0].id} />;
  }

  if (!profile) {
    const descr = t`The dashboard you're looking for does not exist. Head back to the dashboard overview`;
    return <NotFoundPage description={descr} />;
  }

  return (
    <LayersApiContext.Provider value={layersApiContextValue}>
      <TimeMachineProvider>
        <WorkspacePage />
      </TimeMachineProvider>
    </LayersApiContext.Provider>
  );
}
